/**
 * Documents come from `/documents/:orderId` and the trucks from the order;
 * both lists hold the same trucks but nothing guarantees the same order or
 * length (a truck without uploads yet, a truck added later), so they are
 * matched by truck id rather than by position.
 */
export const findTruckDocuments = <T extends { id: number }>(
	docs: T[] | undefined,
	truckId: number | undefined,
): T | undefined =>
	truckId === undefined ? undefined : docs?.find((doc) => doc.id === truckId);
